import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Dispatch } from 'redux';
import urlencode from 'urlencode';
import { checkResetPasswordToken, dialogClear } from '../../../stores/auth/actionCreators';
import { invalidToken, isLoggedIn, resetPasswordSuccess } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import CenterContainer from '../../layout/CenterContainer';
import LoadingScreen from '../../navigation/LoadingScreen';
import ResetPasswordDialog from './ResetPasswordDialog';
import ResetPasswordError from './ResetPasswordError';
import ResetPasswordSuccess from './ResetPasswordSuccess';

interface Props extends LocalizeContextProps, RouteComponentProps<{ id: string }> {
    isLoggedIn: boolean;
    success: boolean;
    invalidToken?: boolean;

    dialogClear: () => void;
    checkPasswordResetToken: (id: string, token: string) => void;
}

class ResetPasswordPage extends React.Component<Props> {
    public componentWillMount() {
        this.props.dialogClear();
        const { token } = urlencode.parse(this.props.location.search.substr(1), { charset: 'utf8' });
        this.props.checkPasswordResetToken(this.props.match.params.id, token);
    }

    public render() {
        const t = this.props.translate;
        const { token } = urlencode.parse(this.props.location.search.substr(1), { charset: 'utf8' });

        if (this.props.invalidToken === undefined) {
            return (
                <LoadingScreen text={t('resetPassword.loading.loading') as string} />
            );
        }

        if (this.props.invalidToken) {
            return (
                <CenterContainer>
                    <ResetPasswordError />
                </CenterContainer>
            );
        }

        if (this.props.success) {
            return (
                <CenterContainer>
                    <ResetPasswordSuccess />
                </CenterContainer>
            );
        }

        return (
            <CenterContainer>
                <ResetPasswordDialog id={this.props.match.params.id} token={token} />
            </CenterContainer>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    invalidToken: invalidToken(state),
    isLoggedIn: isLoggedIn(state),
    success: resetPasswordSuccess(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    checkPasswordResetToken: (id: string, token: string) =>
        dispatch(checkResetPasswordToken(id, token)),
    dialogClear: () => dispatch(dialogClear()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(ResetPasswordPage)));
